import React from 'react';
import {
  getStatusColor,
  getStatusColorCategory,
  getStatusDisplayLabel,
  isSourceProfileStatus,
  isSystemBadgeStatus,
} from '../../utils/candidateStatus';

const SYSTEM_VARIANTS = {
  Active: 'success',
  InActive: 'danger',
  Inactive: 'danger',
  high: 'danger',
  medium: 'warning',
  low: 'info',
  'N/A': 'neutral',
};

function StatusBadge({ status, className = '', useStoredLabel = false }) {
  if (isSystemBadgeStatus(status)) {
    const displayStatus = status === 'InActive' ? 'Inactive' : status;
    const variant = SYSTEM_VARIANTS[status] || 'neutral';
    return (
      <span className={`hr-badge ${variant} ${className}`.trim()}>
        {displayStatus}
      </span>
    );
  }

  if (isSourceProfileStatus(status)) {
    const label = useStoredLabel ? (status || 'No Action Taken') : getStatusDisplayLabel(status);
    return (
      <span
        className={`hr-source-status is-${getStatusColorCategory(status)} ${className}`.trim()}
        style={{ color: getStatusColor(status) }}
      >
        {label}
      </span>
    );
  }

  const variant = SYSTEM_VARIANTS[status] || 'neutral';
  return (
    <span className={`hr-badge ${variant} ${className}`.trim()}>
      {status || 'N/A'}
    </span>
  );
}

export default StatusBadge;
